import React from 'react';
import './NoteSearchInput.css';
import { TbSearch } from "react-icons/tb";
import { useLanguage } from '../../../../LanguageProvider';

const NoteSearchInput = ({ onSearch, value, style, placeholder }) => {
    const { getTranslation } = useLanguage();
    return (
        <div className="note-search-container"
            style={style}
        >
            <span className="note-search-icon"><TbSearch size={16} /></span>
            <input
                type="text"
                value={value}
                className="note-search-input"
                placeholder={placeholder ? placeholder : getTranslation('searchInAllNotes')}
                onChange={(e) => onSearch && onSearch(e.target.value)}
            />
        </div>
    );
};

export default NoteSearchInput;
